var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99708 4.74111C9.34617 4.12836 9.99716 3.75001 10.7024 3.75C11.9378 3.74999 12.8659 4.87768 12.6284 6.09001L11.963 9.48587C11.9601 9.50042 11.9616 9.50931 11.9637 9.51569C11.9661 9.52355 11.9712 9.53276 11.9795 9.5413C11.9879 9.54984 11.997 9.5551 12.0048 9.55774C12.0111 9.55988 12.02 9.5616 12.0346 9.55906L15.4504 8.96579C17.3966 8.62777 19.1101 10.2789 18.8444 12.2363C18.8129 12.4681 18.7537 12.6952 18.6681 12.9129L16.964 17.2435C16.5467 18.3039 15.6806 19.1246 14.5992 19.4843C13.0544 19.9981 11.4152 20.1648 9.79856 19.9725L7.68151 19.7207C6.4173 19.5703 5.42383 18.5679 5.28477 17.3024L4.93163 14.0887C4.79921 12.8837 5.05103 11.6677 5.65111 10.6143L8.99708 4.74111Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconFilled);
export default __webpack_public_path__ + "static/media/like-icon-filled.c4bf0386.svg";
export { ForwardRef as ReactComponent };